import jwt_decode from "jwt-decode";

import { InvalidTokenError } from "@/errors/auth.errors";
import { IDecodedToken } from "@/interfaces/auth.interfaces";

export const generateDecodedToken = (_accessToken: string): IDecodedToken | null => {
  const decoded: IDecodedToken = jwt_decode(_accessToken);
  if (!decoded) return null;
  return decoded;
};

export function decodeToken(accessToken: string): IDecodedToken {
  const decoded = generateDecodedToken(accessToken);
  if (!decoded) throw new InvalidTokenError();
  return decoded;
}

export const checkIfTokenIsExpired = (decodedToken: IDecodedToken): boolean => {
  const expiration = decodedToken.exp * 1000;
  const currentDate = new Date().getTime();
  const isExpired = currentDate > expiration;
  return isExpired;
};
